function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMvInfo03B = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 140,
  height: 140
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M96.98 91.763V56.957h-53v109h29",
  "data-name": "Path 79",
  style: {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3,
    strokeLinejoin: "round"
  },
  transform: "translate(-11.864 -41.525)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M72.98 157.957h-22v-44h22",
  "data-name": "Rectangle 48",
  style: {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3,
    strokeLinejoin: "round"
  },
  transform: "translate(-11.864 -41.525)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M72.98 98.957h-22",
  "data-name": "Line 7",
  style: {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3,
    strokeLinejoin: "round"
  },
  transform: "translate(-11.864 -41.525)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M90.98 74.677h-9s-3 4.28-11 4.28",
  "data-name": "Path 81",
  style: {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3,
    strokeLinejoin: "round"
  },
  transform: "translate(-11.864 -41.525)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.98 74.677h9s3 4.28 11 4.28",
  "data-name": "Path 82",
  style: {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3,
    strokeLinejoin: "round"
  },
  transform: "translate(-11.864 -41.525)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M58.817 92.134a91 91 0 0 0 12.663.823c8.18 0 15.44-.94 20-2.39v-26.61h-40v44h21.5",
  "data-name": "Path 83",
  style: {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3,
    strokeLinejoin: "round"
  },
  transform: "translate(-11.864 -41.525)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M84.142 92.134a91 91 0 0 1-12.663.823c-8.18 0-15.44-.94-20-2.39v-26.61h40",
  "data-name": "Path 83",
  style: {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3,
    strokeLinejoin: "round"
  },
  transform: "translate(-11.864 -41.525)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M119.749 152.339v12.036a1.72 1.72 0 0 1-1.72 1.719H82.7a1.72 1.72 0 0 1-1.72-1.72v-61.516a1.72 1.72 0 0 1 1.72-1.72h35.33a1.72 1.72 0 0 1 1.719 1.72v49.48",
  "data-name": "Rectangle 94",
  style: {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  },
  transform: "translate(-11.864 -41.525)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M111.707 101.333c0 2.366.095 4.283-3.771 4.283H91.745c-3.731 0-3.772-1.918-3.772-4.283v0",
  "data-name": "Path 214",
  style: {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  },
  transform: "translate(-11.864 -41.525)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M93.716 160.951h13.299",
  "data-name": "Line 83",
  style: {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  },
  transform: "translate(-11.864 -41.525)"
}), /*#__PURE__*/React.createElement("path", {
  strokeMiterlimit: 10,
  d: "m92.272 132.42 5.73 5.423 10.515-10.514",
  "data-name": "Path 227",
  style: {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  },
  transform: "translate(-11.864 -41.525)"
}));
export { SvgMvInfo03B as ReactComponent };
export default "data:image/svg+xml;base64,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";